import { render, staticRenderFns } from "./xunjiang-pro-audit.vue?vue&type=template&id=85715242&scoped=true"
import script from "./xunjiang-pro-audit.vue?vue&type=script&lang=js"
export * from "./xunjiang-pro-audit.vue?vue&type=script&lang=js"
import style0 from "./xunjiang-pro-audit.vue?vue&type=style&index=0&id=85715242&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85715242",
  null
  
)

export default component.exports